import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {useLocation} from '@app/hooks/use-location';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const DevicesSection: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();

	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'featureslandingpage_title_streamacrossalldevices_standalone-web',
							{ns: 'features'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_streamacrossalldevices_standalone-web',
							{ns: 'features'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					alt={t('metatag_text_deezerforalldevices_standalone-web', {
						ns: 'common',
					})}
					maxW={{base: '350px', md: '750px'}}
					aspectRatio="828/498"
					quality={90}
					src="c347a2006e0fbcde6736a78e8b3d6e79.png"
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'devices'}}
					href={getDeezerUrl('/devices')}
				>
					{t('generic_action_discovercompatibledevices_standalone-web', {
						ns: 'common',
					})}
				</LandingButtonLink>
			}
		/>
	);
};
